import React from 'react';
import PartnerCard from './PartnerCard';
import { Partner } from '../../../../types/partnerType';

interface PartnersGridProps {
  partners: Partner[];
  title?: string;
  subtitle?: string;
  loading?: boolean;
  error?: string | null;
}

/**
 * PartnersGrid Component
 * Displays a grid of partner cards with optional title and subtitle
 */
const PartnersGrid: React.FC<PartnersGridProps> = ({ 
  partners, 
  title = "Đối tác của chúng tôi",
  subtitle = "Những đối tác tin cậy đồng hành cùng chúng tôi trong hành trình phát triển bền vững",
  loading = false,
  error = null
}) => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="mx-auto max-w-7xl px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4">
            {title}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {subtitle}
          </p>
        </div>

        {/* Error State */}
        {error && (
          <div className="text-center py-12">
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 max-w-md mx-auto">
              <p className="text-red-600">
                {error}
              </p>
            </div>
          </div>
        )}

        {/* Loading State */}
        {loading && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[...Array(4)].map((_, index) => (
              <div key={index} className="bg-white rounded-lg border border-gray-200 p-6 animate-pulse">
                <div className="flex justify-center items-center h-20 mb-4">
                  <div className="w-32 h-16 bg-gray-200 rounded"></div>
                </div>
                <div className="h-6 bg-gray-200 rounded mb-3"></div>
                <div className="space-y-2">
                  <div className="h-4 bg-gray-200 rounded"></div>
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Partners Grid */}
        {!loading && !error && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {partners.map((partner) => (
              <PartnerCard
                key={partner.id}
                partner={partner}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default PartnersGrid;
